import {observer} from "mobx-react";
import {Button} from "@mui/material";
import {useStore} from "../../stores/Store";
import AddIcon from '@mui/icons-material/Add';

export default observer(function AccordionCreateDialog(){
    const { LanguageStore, AccordionStore } = useStore();

    const handleClick = () => {
        AccordionStore.create();
    }

    return (
        <Button
            color={'success'}
            variant={'contained'}
            startIcon={<AddIcon />}
            onClick={handleClick}
        >
            { LanguageStore.currentLanguageMessages.GeneralComponentLabels.createButtonLabel }
        </Button>
    )
})